import { render, staticRenderFns } from "./icons-collection.vue?vue&type=template&id=0c6afcbf&scoped=true"
import script from "./icons-collection.vue?vue&type=script&lang=js"
export * from "./icons-collection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6afcbf",
  null
  
)

export default component.exports